import { strict } from "assert";

export class EnableToSend {

  Id:number;
  Name:string;
  
  constructor(_id:number, _name:string){
    this.Id = _id;
    this.Name = _name;
   }
}